export enum BillingModeT {
  LOCAL_CURRENCY_MODE = 'LOCAL_CURRENCY_MODE',
  EURO_MODE = 'EURO_MODE',
}
